<template>
    <div class="card card-with-shadow border-0">
        <div class="card-body p-primary">
            <div class="position-relative" style="min-height: 400px">
                <app-overlay-loader v-if="preloader"/>
                <div v-else class="calendar-view" :class="{'loading-opacity': preloader}">
                    <FullCalendar
                        ref="fullCalendar"
                        :defaultView="defaultView"
                        :header="header"
                        :plugins="calendarPlugins"
                        :slotLabelFormat="timeFormat===24?{ 'hour12': false, 'hour': '2-digit', 'minute': '2-digit'}:false"
                        :views="views"
                        :events="events"
                        :selectable="true"
                        :defaultDate="defaultDate"
                        :editable="options.editable!==false"
                        @_eventsPositioned="setView"
                        v-on="listeners"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import coreLibrary from '../../helpers/CoreLibrary';

export default {
    name: "Calendar",
    components: {FullCalendar},
    extends: coreLibrary,
    props: {
        options: {
            type: Object,
            require: true
        },
        filteredData: {
            type: Object
        },
        searchValue: {
            type: String
        },
        id: {
            type: String,
            require: true
        }
    },
    data() {
        return {
            defaultDate: new Date(),
            defaultView: 'timeGridWeek',
            calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            header: {
                left: 'title',
                center: 'prev today next',
                right: 'dayGridMonth,timeGridWeek,timeGridDay',
            },
            views: {
                dayGridMonth: {
                    titleFormat: {month: 'long', year: 'numeric'},
                    columnHeaderFormat: {
                        weekday: 'short'
                    }
                },
                timeGridWeek: {
                    titleFormat: {month: 'long', year: 'numeric'},
                    columnHeaderHtml: function (date) {
                        if (date.getDay() === 1) {
                            let day = date.getDate();
                            return '<div class="fc-calendar-date-name">Mon</div><div class="fc-calendar-day-name">' + day + '</div>';
                        } else if (date.getDay() === 2) {
                            let day = date.getDate();
                            return '<div class="fc-calendar-date-name">Tue</div><div class="fc-calendar-day-name">' + day + '</div>';
                        } else if (date.getDay() === 3) {
                            let day = date.getDate();
                            return '<div class="fc-calendar-date-name">Wed</div><div class="fc-calendar-day-name">' + day + '</div>';
                        } else if (date.getDay() === 4) {
                            let day = date.getDate();
                            return '<div class="fc-calendar-date-name">Thu</div><div class="fc-calendar-day-name">' + day + '</div>';
                        } else if (date.getDay() === 5) {
                            let day = date.getDate();
                            return '<div class="fc-calendar-date-name">Fri</div><div class="fc-calendar-day-name">' + day + '</div>';
                        } else if (date.getDay() === 6) {
                            let day = date.getDate();
                            return '<div class="fc-calendar-date-name">Sat</div><div class="fc-calendar-day-name">' + day + '</div>';
                        } else {
                            let day = date.getDate();
                            return '<div class="fc-calendar-date-name">Sun</div><div class="fc-calendar-day-name">' + day + '</div>';
                        }
                    },
                    weekNumbers: true
                },
                timeGridDay: {
                    titleFormat: {day: 'numeric', month: 'long', year: 'numeric'},
                    columnHeaderFormat: {
                        weekday: 'long'
                    }
                }
            },
            preloader: false,
            events: [],
            filteredValues: {},
            search: null
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                select: event => {
                    this.$emit('createEvent', event);
                },
                eventClick: event => {
                    this.$emit('selectedEvent', event);
                },
                eventResize: event => {
                    this.$emit('eventResize', event);
                },
                eventDrop: event => {
                    this.$emit('eventDrop', event);
                }
            }
        },
        dateFilterKey() {
            return this.options.filters?.find(element => element.type === 'range-picker')?.key;
        }
    },
    mounted() {
        this.calendarInit();
        this.reloadCalendar();
        this.setInitialView();
    },
    methods: {
        calendarInit() {
            this.filteredValues = this.filteredData;
            this.search = this.searchValue;
            this.events = [];
            this.getCalendarEvents();
        },
        getCalendarEvents() {
            let filter = this.filteredValues,
                reqData = {},
                url = this.options.url;
            filter.search = this.search;
            reqData.params = filter;
            this.setPreloader(true);
            this.axiosGet(
                url,
                reqData
            ).then(response => {
                this.events = response.data;
            }).catch(({response}) => {

                // trigger after error

            }).finally(() => {
                this.setPreloader(false);
            });
        },
        reloadCalendar() {
            let name = 'reload-' + this.id;
            this.$hub.$on(name, (value = true) => {
                if (value) {
                    this.calendarInit();

                    // after reload calendar view modified
                    if(!this.isUndefined(this.dateFilterKey)){
                        if (this.filteredData[this.dateFilterKey]?.start) {
                            this.defaultDate = new Date(this.filteredData[this.dateFilterKey].start);
                        } else this.defaultDate = new Date();
                    }
                    this.setInitialView();
                }
            });
        },
        setPreloader(val) {
            this.preloader = val;
        },

        setView() {
            $('.fc-dayGridMonth-button').click(() => {
                localStorage.setItem('calendar-default-view', 'dayGridMonth');
            });
            $('.fc-timeGridWeek-button').click(() => {
                localStorage.setItem('calendar-default-view', 'timeGridWeek');
            });
            $('.fc-timeGridDay-button').click(() => {
                localStorage.setItem('calendar-default-view', 'timeGridDay');
            })
        },
        setInitialView() {
            let x = localStorage.getItem("calendar-default-view");
            if (x) {
                this.defaultView = x;
            }
        }
    }
}
</script>

